<template>
    <b-card class="mt-2">
        <div class="text-center">
            <b-btn
                class="mb-2"
                variant="secondary btn-outline"
                pill
                @click="toggleEdit()"
            >
                <template v-if="disabled">
                    <font-awesome-icon class="mr-2" icon="pencil-alt"></font-awesome-icon>
                    Edit Account Information
                </template>
                <template v-else>
                    <font-awesome-icon class="mr-2" icon="times"></font-awesome-icon>
                    Cancel
                </template>
            </b-btn>
        </div>
        <b-form>
            <b-form-group
                label="Login Email"
                label-class="font-weight-bold"
                :disabled="disabled"
            >
                <b-form-input v-model="userData.email"></b-form-input>
            </b-form-group>
            <b-form-group
                label="First Name"
                label-class="font-weight-bold"
                :disabled="disabled"
            >
                <b-form-input v-model="userData.first_name"></b-form-input>
            </b-form-group>
            <b-form-group
                label="Spouse's First Name"
                label-class="font-weight-bold"
                :disabled="disabled"
            >
                <b-form-input v-model="userData.spouse_name"></b-form-input>
            </b-form-group>
            <b-form-group
                label="Last Name"
                label-class="font-weight-bold"
                :disabled="disabled"
            >
                <b-form-input v-model="userData.last_name"></b-form-input>
            </b-form-group>
        </b-form>
        <div class="text-center">
            <b-button
                variant="primary"
                pill
                :disabled="disabled"
                v-b-modal.modal-1
            >
                <font-awesome-icon class="mr-2" icon="save"></font-awesome-icon>
                Save Changes
            </b-button>
        </div>
        <b-modal
            id="modal-1"
            title="Confirm Change"
            ok-title="Save Changes"
            @ok="trySave()"
            @cancel="getEditableUserData()"
        >
            <p>Confirm changes to your account by verifying your current password (or temporary pin).</p>
            <b-form-group
                label="Current password (or temporary pin)"
                label-class="font-weight-bold"
            >
                <b-form-input v-model="currentPassword" type="password"></b-form-input>
            </b-form-group>
        </b-modal>
    </b-card>
</template>
<script>
import dtPicker     from "@/components/form/DateTimePicker.vue"
import { mapState } from "vuex"

export default {
    name: "account-info-form",
    components: { dtPicker },
    data() {
        return {
            disabled: true,
            currentPassword: "",
            userData: {}
        };
    },
    mounted() {
        setTimeout(() => {
            this.getEditableUserData();
        }, 10);
    },
    methods: {
        toggleEdit() {
            this.disabled = !this.disabled;
            this.getEditableUserData();
        },
        getEditableUserData() {
            this.$set(this.userData, "email", this.user.email);
            //this.userData.email = this.user.email;
            ["first_name", "last_name", "birthdate"].forEach((key) => {
                this.$set(this.userData, key, this.user.person[key]);
            });
            this.$set(this.userData, "spouse_name", (this.user.person2) ? this.user.person2.first_name : "");
        },
        trySave() {
            this.$api.post(
                "/api/account/saveInfo",
                {
                    currentPassword : this.currentPassword,
                    userData        : this.userData
                }
            ).then((response) => {
                const data = response.data;
                if (data.success) {
                    this.disabled = true;
                    window.location.reload();
                }
                this.$bvToast.toast(data.message, {
                    title:   (data.success) ? "Success" : "Error",
                    variant: (data.success) ? "success" : "danger",
                    autoHideDelay: 5000,
                    appendToast: true
                });
            });
        }
    },
    computed: mapState(["user", "appLoaded"])
}
</script>